import { Flex, Space, Text } from '@mantine/core';
import { StudyDashboardDetailPage } from '../../../../../component/page';
import { PastRaffles } from '../components';
import { useWindowSize } from '../../../../../../src/hooks';
import { useTranslation } from 'react-i18next';

export const PastRafflesScreen = () => {
  const { t } = useTranslation('raffle');
  const isSmallScreen = useWindowSize(600);

  return (
    <StudyDashboardDetailPage
      breadcrumbText={`/ ${t('BreadcrumbText')} / ${t('PastRaffles')} `}
    >
      <Flex direction="column" gap="0.5em" style={{ width: '100%' }}>
        <Flex
          gap={20}
          justify={isSmallScreen ? 'flex-start' : 'space-between'}
          direction={isSmallScreen ? 'column' : 'row'}
        >
          <Text fw="600" size="28px" lh="38px">
            {t('PastRaffles')}
          </Text>
        </Flex>
        <Space h="10px" />
        <PastRaffles />
      </Flex>
    </StudyDashboardDetailPage>
  );
};
